export const GetTable = () => {
    const uri = window.location.href;
    let datas = {};
    if (uri.includes('personnage') || uri.includes('rendez-vous')) {
        datas = { label: 'personnage', table: 'characters' };
    } else if (uri.includes('films-et-series') || uri.includes('origine')) {
        datas = { label: 'origines', table: 'origin' };
    } else if (uri.includes('experience')) {
        datas = { label: 'experience', table: 'experiment' };
    } else {
        datas = { label: 'attraction', table: 'attraction' };
    }
    return datas;
}